"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _bind = _interopRequireDefault(require("classnames/bind"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _icon = _interopRequireDefault(require("../icon"));

var _loader = _interopRequireDefault(require("../loader"));

var _notification = _interopRequireDefault(require("../notification"));

var _messages = _interopRequireDefault(require("./messages"));

var _style = _interopRequireDefault(require("./style.css"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_style["default"]);

var acceptedTypes = ['image/gif', 'image/jpg', 'image/jpeg', 'image/png', '.gif', '.jpg', '.jpeg', '.png'].join(',');

var _ref = /*#__PURE__*/_jsx(_loader["default"], {
  color: "blue",
  fullscreen: true
});

var _ref2 = /*#__PURE__*/_jsx(_loader["default"], {
  color: "blue",
  fullscreen: true,
  size: "xs"
});

var ImagePicker = /*#__PURE__*/function (_PureComponent) {
  _inherits(ImagePicker, _PureComponent);

  var _super = _createSuper(ImagePicker);

  function ImagePicker() {
    var _this;

    _classCallCheck(this, ImagePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      fetching: false,
      error: null
    });

    return _this;
  }

  _createClass(ImagePicker, [{
    key: "onDrop",
    value: function onDrop(files) {
      var _this2 = this;

      var _this$props = this.props,
          intl = _this$props.intl,
          HTTPClient = _this$props.HTTPClient,
          input = _this$props.input,
          url = _this$props.url,
          responseKey = _this$props.responseKey,
          onUploadStart = _this$props.onUploadStart,
          onUploadEnd = _this$props.onUploadEnd,
          maxSize = _this$props.maxSize;

      if (maxSize && files[0].size > maxSize) {
        this.setState({
          error: intl.formatMessage(_messages["default"].maxSizeError, {
            fileSize: files[0].size / 1024 / 1024,
            maxSize: maxSize / 1024 / 1024
          })
        });
        return;
      }

      var computedHTTPClient = HTTPClient || _axios["default"];

      if (input.onDrop) {
        input.onDrop();
      }

      var data = new FormData();
      data.append('image', files[0]);
      this.setState({
        fetching: true,
        error: false
      });
      onUploadStart();
      computedHTTPClient.post(url, data, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }).then(function (response) {
        var data = response.data[responseKey];
        input.onChange(data);
        onUploadEnd(data);
        setTimeout(function () {
          return _this2.setState({
            fetching: false
          });
        }, 2000);
      })["catch"](function (error) {
        onUploadEnd(undefined, error);

        _this2.setState({
          fetching: false,
          error: error.response ? error.response.data.message : 'Error'
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          intl = _this$props2.intl,
          input = _this$props2.input,
          meta = _this$props2.meta,
          appearance = _this$props2.appearance,
          caption = _this$props2.caption,
          disabled = _this$props2.disabled,
          dataId = _this$props2.dataId,
          rest = _objectWithoutProperties(_this$props2, ["intl", "input", "meta", "appearance", "caption", "disabled", "dataId"]);

      var _this$state = this.state,
          fetching = _this$state.fetching,
          error = _this$state.error;
      var imageName = input.value ? input.value.split('/').pop() : null;
      var isError = meta.touched && meta.error;
      var isWarning = meta.touched && !meta.error && !error && meta.warning;
      return /*#__PURE__*/_jsx("div", {
        "data-id": dataId || input.name || rest.name
      }, void 0, /*#__PURE__*/_jsx(_reactDropzone["default"], {
        name: input.name || rest.name,
        className: cx('xsui-imagePicker', "xsui-imagePicker--appearance-".concat(appearance), fetching && 'xsui-imagePicker--fetching', input.value && 'xsui-imagePicker--filled', isError && 'xsui-imagePicker--error', isWarning && 'xsui-imagePicker--warning', error && 'xsui-imagePicker--error'),
        acceptClassName: cx('xsui-imagePicker--accept'),
        rejectClassName: cx('xsui-imagePicker--reject'),
        disabledClassName: cx('xsui-imagePicker--disabled'),
        accept: acceptedTypes,
        multiple: false,
        disabled: disabled || fetching,
        disablePreview: true,
        onDrop: this.onDrop.bind(this)
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: cx('xsui-imagePicker__icon')
      }, void 0, /*#__PURE__*/_jsx(_icon["default"], {
        name: input.value ? 'delete' : 'upload',
        size: appearance === 'secondary' ? 24 : input.value ? 24 : 32,
        hoverable: !disabled,
        onClick: function onClick(e) {
          e.stopPropagation();
          !disabled && input.onChange(null);
        }
      })), (appearance === 'primary' || appearance === 'tertiary') && /*#__PURE__*/_jsx(_react.Fragment, {}, void 0, fetching && _ref, !fetching && input.value && /*#__PURE__*/_jsx("div", {
        className: cx('xsui-imagePicker__preview'),
        style: {
          backgroundImage: "url(".concat(input.value, ")")
        }
      })), appearance === 'secondary' && /*#__PURE__*/_jsx(_react.Fragment, {}, void 0, fetching && _ref2, /*#__PURE__*/_jsx("div", {
        className: cx('xsui-imagePicker__caption')
      }, void 0, imageName || caption || intl.formatMessage(_messages["default"].caption)))), /*#__PURE__*/_jsx("div", {}, void 0, isError && /*#__PURE__*/_jsx(_notification["default"], {
        appearance: "string",
        status: "error"
      }, void 0, meta.error), isWarning && /*#__PURE__*/_jsx(_notification["default"], {
        appearance: "string",
        status: "warning"
      }, void 0, meta.warning), error && /*#__PURE__*/_jsx(_notification["default"], {
        appearance: "string",
        status: "error"
      }, void 0, error)));
    }
  }]);

  return ImagePicker;
}(_react.PureComponent);

_defineProperty(ImagePicker, "defaultProps", {
  input: {},
  meta: {
    touched: false,
    error: null
  },
  name: null,
  responseKey: 'image_url',
  appearance: 'primary',
  onUploadStart: function onUploadStart() {
    return void 0;
  },
  onUploadEnd: function onUploadEnd() {
    return void 0;
  },
  disabled: false
});

var _default = (0, _reactIntl.injectIntl)(ImagePicker);

exports["default"] = _default;